import React from 'react';
import { FormProvider, useForm } from "react-hook-form";
import { usageFormSchema } from '@/schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { actions, useStore } from '@/store';
import WizardButtons from '@/Wizard/WizardButtons';
import { NextButton, PrevButton, ResetButton } from '@/Shared/Buttons';
import PersonalDataToThirdCountries from './PersonalDataToThirdCountries';
import ShareCollectInfo from './ShareCollectInfo';

const UsageStep = ({ stepName }) => {
  const [
    usageFormValue, 
    setUsageFormValue
  ] = useStore(state => [state.usageFormValue, state.setUsageFormValue])

  const formMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
    defaultValues: usageFormValue,
    resolver: yupResolver(usageFormSchema),
  });

  const onSubmit = (data) => {
    setUsageFormValue(data)
    actions.handleWizardNextStep()
  }


  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <div className="card shadow-lg">
          <div className="card-header">
            <h3 className="card-title">
              Tell us how exactly do you use collected information, how can it be shared and what types of third-
              party services do you use.
            </h3>
          </div>  
          <div className="card-body">
            <div className='row'>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold'>How do you share collected information?</p>
                <div className='d-flex flex-column'>
                  <ShareCollectInfo />
                </div>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold'>Is personal data intended to be transferred to a third country?</p>
                <div className='d-flex flex-column'>
                  <PersonalDataToThirdCountries />
                </div>
              </div>
            </div>  
          </div>
          <div className='card-footer'>
            <WizardButtons>
              <>
                <PrevButton onClick={() => actions.handleWizardPrevStep()} />
                <ResetButton onClick={() => actions.handleWizardReset()} />
                <NextButton type='submit' />
              </>
            </WizardButtons>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default UsageStep;